import styled from "styled-components";

export const SearchBarContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 20px;
`;

export const SearchInput = styled.input`
    
`;

export const SearchButton = styled.button`
    margin-left: 10px;
`;